<template>
  <Layout>
    <div class="filters_row">
      <div></div>

      <TimelineLink />
    </div>
    <div class="filters_devider"></div>

    <PageTitle />

    <div class="page-padding page-padding-all">
      <PaymentsTable />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'

import PaymentsTable from './paymentsTable/PaymentsTable.vue'
import TimelineLink from './TimelineLink.vue'

export default {
  page: {
    title: 'Платежи',
  },
  components: {
    Layout,
    PaymentsTable,
    PageTitle: () => import('./PageTitle.vue'),
    TimelineLink,
  },
}
</script>
